import { render, staticRenderFns } from "./Game.vue?vue&type=template&id=9b989182&scoped=true&"
import script from "./Game.vue?vue&type=script&lang=ts&"
export * from "./Game.vue?vue&type=script&lang=ts&"
import style0 from "./Game.vue?vue&type=style&index=0&id=9b989182&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b989182",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/Romppu/source/repos/poker-serverless/pokerapp/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VFlex,VIcon,VImg,VLayout,VTextField})
